<script lang="ts" setup>
export interface PagesContactsAssistenceServicesProps {
    data: Service[]
}

const { $t } = useNuxtApp()
const props = defineProps<PagesContactsAssistenceServicesProps>()
const title = $t('Ďalšie kontakty')
const attrs = useAttrs()
</script>

<template>
  <Tracker :data="{ position: title }">
    <section v-bind="attrs">
      <BoxHeader
        :heading="title"
        heading-level="h2"
      />

      <div class="row g-2 g-md-6 justify-content-center">
        <div
          v-for="(service, serviceIndex) in props.data"
          :key="`assistance-service-${serviceIndex}`"
          class="col-12 col-sm-6 col-md-4 col-lg-3"
        >
          <ServiceCard :service="service" />
        </div>
      </div>
    </section>
  </Tracker>
</template>
